<template >
  <div v-if="!updating && showPickupPersonBlock.state.value" class="section-row">
    <div class="vue-form">
      <div class="vue-form-row">
        <vue-input @blur="setPickupPersonFieldValue({ fieldId:'isSomeoneElse', value: $event.target.value })"
          :element="isSomeoneElse" />
      </div>
      <div v-if="isSomeoneElse.state.value" class="pickup-person-form">
        <span class="section-row-description"> {{ resources.description }}</span>
        <div class="vue-form-row has-multiple-elements">
          <vue-input @blur="setPickupPersonFieldValue({ fieldId:'firstName', value: $event.target.value })"
            :element="firstName" />
          <vue-input @blur="setPickupPersonFieldValue({ fieldId:'lastName', value: $event.target.value })"
            :element="lastName" />
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./pickup-person.js"/>
